/*************************
 * @license
 * Copyright 2024 Myenergi Ltd. All rights reserved.
 * No part of this work may be reproduced, stored in a retrieval system of any nature, or transmitted, in any form or by any means without the prior written permission of Myenergi Ltd., the copyright owner.
 * If any unauthorised acts are carried out in relation to this copyright work, a civil claim for damages may be made and/or a criminal prosecution may result.
 *************************/
import { action, makeObservable, observable } from "mobx";
import getRandomColor from "containers/Users/utils/random-color";
import { persist } from "mobx-persist";
import { StoreBase } from "./StoreBase";

class ColorStore extends StoreBase {
  @observable @persist("object") colorObj: Record<string, string[]> = {};

  constructor() {
    super();
    makeObservable(this);
  }

  @action.bound
  public getColorAmount(name: string, amount: number) {
    if (!this.colorObj[name]) {
      this.colorObj[name] = [];
    }

    this.createColorsIfNeeded(name, amount);

    return this.colorObj[name];
  }

  @action.bound
  private createColorsIfNeeded(name: string, amount: number) {
    if (this.colorObj[name].length < amount) {
      const totalColors = amount - this.colorObj[name].length;

      for (let i = totalColors; i >= 0; i -= 1) {
        this.colorObj[name].push(getRandomColor());
      }
    }
  }
}

export default ColorStore;
